import React from "react";

const TestDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <h1 className="text-3xl font-bold text-center mb-8">Test Dashboard</h1>
      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold mb-4">Dashboard Access Test</h2>
        <p className="text-gray-700 mb-4">
          If you can see this page, the routing is working correctly!
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-blue-50 p-4 rounded">
            <h3 className="font-semibold text-blue-800">
              Authentication Status
            </h3>
            <p className="text-blue-600">
              Dashboard is accessible to all users
            </p>
          </div>
          <div className="bg-green-50 p-4 rounded">
            <h3 className="font-semibold text-green-800">Route Protection</h3>
            <p className="text-green-600">No authentication required</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestDashboard;
